import styled from 'styled-components'

import { PairLink } from '@root/entities/pair/ui/common'

import type { PairAudit, PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
  children: React.ReactNode
  intent?: PairAudit.AuditStatus
} & ClassNameProps &
  Omit<React.HTMLAttributes<HTMLAnchorElement>, 'onClick'>

export const PairExploreItemAuditItem = ({
  children,
  intent,
  pair,
  ...rest // rest is for tooltip
}: Props) => (
  <Root pair={pair} data-intent={intent} {...rest}>
    {children}
  </Root>
)

const Root = styled(PairLink<PairModel>)`
  pointer-events: auto;
  border-radius: 6px;
  padding-inline: 6px;
  height: 24px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  gap: 3px;
  cursor: pointer;
  transition:
    background-color 0.1s linear,
    border-color 0.1s linear,
    color 0.1s linear;

  border: 1px solid var(--backgroundA-3);
  background: var(--backgroundA-1);
  color: var(--background-11);

  font-size: 12px;
  font-weight: 500;

  &:hover {
    border: 1px solid var(--backgroundA-3);
    background: var(--backgroundA-2);
  }

  &[data-intent='Safe'] {
    color: var(--success-9);
    border: 1px solid var(--successA-3);
    background: var(--successA-2);

    &:hover {
      border: 1px solid var(--successA-3);
      background: var(--successA-3);
    }
  }
  &[data-intent='Danger'] {
    color: var(--error-9);
    border: 1px solid var(--errorA-3);
    background: var(--errorA-2);
    &:hover {
      border: 1px solid var(--errorA-4);
      background: var(--errorA-3);
    }
  }
  &[data-intent='Warning'] {
    color: var(--warning-9);
    border: 1px solid var(--warningA-3);
    background: var(--warningA-2);
    &:hover {
      border: 1px solid var(--warningA-4);
      background: var(--warningA-3);
    }
  }
`
